import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.client;

export const clientSelectors = {
    totalItems: createSelector(selector, (client) => client.total_items),
    totalPages: createSelector(selector, (client) => client.total_pages),
    currentPage: createSelector(selector, (client) => client.current_page),
    pageSize: createSelector(selector, (client) => client.page_size),
    nextPage: createSelector(selector, (client) => client.next_page),
    previousPage: createSelector(selector, (client) => client.previous_page),
    clients: createSelector(selector, (client) => client.clients),
    selectedClient: createSelector(selector, (client) => client.selectedClient),
}